export const RESET_CONFIRMATIONS = '[Confirmations] reset';
export const ADD_CONFIRMATION = '[Confirmations] add';
export const DISMISS_CONFIRMATION = '[Confirmations] dismiss';
